import React from 'react';
import type { FormInstance } from 'antd';
import { ToggleField } from '@src/components/Common/Form';
import EvaluationSection from '../Evaluation/EvaluationSection';
import { CaseErrors } from '../Evaluation/utils';

/**
 * What a change instance validator may decide on its own, what it is told about
 * the service, and the declarations it is measured against.
 *
 * Every one of these is a key of `extra_data`, which the API writes as a whole —
 * see AIProcessorCreate's `onFinish` for why they are all sent on every save.
 */
const ValidatorForm = ({
    form,
    record,
    historical,
    readOnly,
    unsaved,
    caseErrors,
}: {
    form: FormInstance;
    record?: any;
    historical?: boolean;
    readOnly?: boolean;
    /** the form is ahead of the server, so a run would use the older prompt and cases */
    unsaved?: boolean;
    caseErrors?: CaseErrors;
}) => (
    <>
        <ToggleField
            name={['extra_data', 'allow_auto_approval']}
            span={3}
            label="Allow auto approval"
            hint="Let the validator approve a change instance without a human review."
        />
        <ToggleField
            name={['extra_data', 'allow_auto_rejection']}
            span={3}
            label="Allow auto rejection"
            hint="Let the validator reject a change instance without a human review."
        />
        <ToggleField
            name={['extra_data', 'send_service_info']}
            span={3}
            label="Send service info"
            hint="Include the service definition in the payload."
        />
        <ToggleField
            name={['extra_data', 'send_existing_service_items']}
            span={3}
            label="Send existing service items"
            hint="Include the service's current service items in the payload."
        />

        <EvaluationSection
            form={form}
            record={record}
            historical={historical}
            readOnly={readOnly}
            unsaved={unsaved}
            caseErrors={caseErrors}
        />
    </>
);

export default ValidatorForm;
